import classNames from "classnames";
import { useLocation, useNavigate } from "react-router-dom";
import { makeLangUrl } from "helpers/makeLangUrl";

// Constants
import { GET_PARAMS } from "constants/popupConfig";
import {
  CATEGORIES_ENUMS,
  CATEGORIES_MAP,
} from "constants/navigation/categories";

// Helpers
import { isUrlActive } from "helpers/is";

// Hooks
import useTranslate from "hooks/useTranslate";
import useQueryParam from "hooks/useQueryParam";

// Types
import { NewCategoryType } from "redux/game/slice";

import "./styles.sass";
import url from "../../../url";

type CategoryMobileItemProps = {
  item: NewCategoryType;
  onSelect: (category: CATEGORIES_ENUMS) => void;
};

const CategoryMobileItem = (props: CategoryMobileItemProps) => {
  const { onSelect } = props;
  // eslint-disable-next-line react/destructuring-assignment
  const { name, translatePlaceholder } = props.item;

  const t = useTranslate();
  const navigate = useNavigate();
  const location = useLocation();
  const category = useQueryParam(GET_PARAMS.CATEGORY);

  const handleClick = () => {
    onSelect(name);
    navigate(makeLangUrl(url.routes.casino.category(`/${name}`)));
  };

  const CategoryMobileItemClass = classNames("CategoryMobileItem", {
    active:
      category === name ||
      (!category &&
        name === CATEGORIES_ENUMS.POPULAR &&
        location.pathname === "/") ||
      (isUrlActive(`/${name}`) && !category),
  });

  return (
    // eslint-disable-next-line react/button-has-type
    <button onClick={handleClick} className={CategoryMobileItemClass}>
      <div className="CategoryMobileItem__icon">
        {CATEGORIES_MAP[name]?.icon}
      </div>
      <div className="CategoryMobileItem__name">{t(translatePlaceholder)}</div>
    </button>
  );
};

export default CategoryMobileItem;
